import { OPEN_MODAL_USER } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (value) => companyUsersActions[OPEN_MODAL_USER](value);
